import React from "react";
import { ShieldCheck, Clock3, Award, MapPin } from "lucide-react";

const reasons = [
  { icon: ShieldCheck, title: "City-Certified Tester", desc: "Laredo-approved with current BPAT credentials. Your filing is accepted the first time." },
  { icon: Clock3, title: "Same-Day Reports", desc: "Finished tests are filed digitally the same day — no waiting, no re-testing charges." },
  { icon: Award, title: "Since 2016 · 8,000+ Jobs", desc: "Thousands of residential and commercial devices tested and repaired across South Texas." },
  { icon: MapPin, title: "Wide Service Area", desc: "Laredo plus Zapata, Cotulla, Freer, McAllen, and Brownsville coverage." },
];

export default function WhyUs() {
  return (
    <section className="bg-slate-50 border-y border-slate-200 py-20 lg:py-24" data-testid="why-us-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-10 items-start">
          <div>
            <div className="step-num">02 — WHY US</div>
            <h2 className="font-display text-4xl sm:text-5xl font-bold mt-3 tracking-tight">
              Local, certified, and quick to respond.
            </h2>
            <p className="text-slate-600 mt-4 max-w-md">
              We're not a call center. When you call {`956-942-5496`}, you reach a certified tester — usually
              same day.
            </p>
            <img
              src="https://images.unsplash.com/photo-1676210133055-eab6ef033ce3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxwbHVtYmVyJTIwdGVjaG5pY2lhbiUyMHdvcmtpbmd8ZW58MHx8fHwxNzc2NTc1MzAwfDA&ixlib=rb-4.1.0&q=85"
              alt="Certified technician working on a backflow device"
              className="mt-8 w-full max-h-[360px] object-cover border border-slate-200"
            />
          </div>

          <div className="grid sm:grid-cols-2 border-l border-t border-slate-200">
            {reasons.map((r) => {
              const Icon = r.icon;
              return (
                <div
                  key={r.title}
                  className="p-6 lg:p-8 bg-white border-r border-b border-slate-200"
                  data-testid={`why-${r.title.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  <div className="w-10 h-10 bg-blue-600 flex items-center justify-center">
                    <Icon className="w-5 h-5 text-white" />
                  </div>
                  <h3 className="font-display font-bold text-xl mt-5 tracking-tight">{r.title}</h3>
                  <p className="text-sm text-slate-600 mt-2 leading-relaxed">{r.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
